import { HttpHeaders } from "@angular/common/http"

export const endpoint = {

    //AUTH MODULE
    LOGIN: 'Auth/Login',
    RESET_PASSWORD: 'Auth/forgot-password/',
    FORGOT_MAIL: 'Auth/forgot-username/',
    CODIGO_NRODOC: 'TablaCodigoRecuperacion/codigo/documento/',
    CODIGO_CODIGO: '/codigo/',
    
    //PACIENTE MODULE
    REGISTER: 'TablaPaciente',
    PACIENTE_GET_BY_ID: 'TablaPaciente/',
    PACIENTE_EDIT: 'TablaPaciente?id=',
    CHANGE_PASSWORD: 'TablaPaciente/change-password?nroDocumento=',
    CHANGE_PASSWORD2: '&newPassword=',
    CHANGE_EMAIL: 'TablaPaciente/change-email?nroDocumento=',
    CHANGE_EMAIL2: '&newEmail=',
    CHANGE_USERNAME: 'TablaPaciente/change-username?nroDocumento=',
    CHANGE_USERNAME2: '&newUsername=',
    
    // LOCALIDAD MODULE
    LOCALIDAD_GET_ALL: 'TablaLocalidad',
    LOCALIDAD_GET_BY_ID: 'TablaLocalidad/',

    // OBRA SOCIAL MODULE
    OBRASOCIAL_GET_ALL: 'TablaObrasocial',
    OBRASOCIAL_GET_BY_ID: 'TablaObrasocial/',
    PACOBRASOCIAL_GET_BY_ID: 'TablaObrasocial/historia/',
    PACOBRASOCIAL_REGISTER: 'TablaObrasocial?historia=',
    PACOBRASOCIAL_ACTIVA: 'TablaObrasocial/obrasocial/',

    // SERVICIOS MODULE
    SERVICIO_CONSULTA: 'TablaServicios/consulta',
    SERVICIO_TURNO: 'TablaServicios/turno',

    // AGENDA MODULE
    SERVICIO_CONSULTA_BY_SERVICIO: 'TablaAgenda/consulta/',
    SERVICIO_CONSULTA_BY_SERVICIO_ATENCION: 'TablaAgenda/consulta-atencion/',

    // PROFESIONAL MODULE
    PROFESIONAL_BY_SERVICIO: 'TablaProfesional/servicio/',
    PROFESIONAL_BY_OBRASOCIAL: '/obra-social/',
    PROFESIONAL_OBSERVACION_WEB: 'TablaProfesional/observacion/',
    PROFESIONAL_TURNOS_DISPONIBLES: 'TablaAgenda/turno-disponible/',
    PROFESIONAL_PRIMER_TURNO_DISPONIBLES: 'TablaAgenda/primer-turno-disponible/',

    // CALENDARIO MODULE    
    CALENDARIO_FERIADOS: 'TablaCalendario',

    // CITA MODULE
    CITA_ADD: 'TablaCita',
    CITA_TURNOS: 'TablaCita/turnos/',
    CITA_INFO: 'TablaCita/infocita/',
    CITA_DELETE: 'TablaCita?numero=',
    CITA_CONFIRM_WHATSAPP: 'TablaCita?numero=',
    CITA_CENCEL_WHATSAPP: 'TablaCita/Turno/',
    CITA_INFO_WHATSAPP: 'TablaCita/infocitaWhatsapp/',

}

export const httpOptions = {
    headers: new HttpHeaders({
        "Content-Type": "application/json"
    })
}